import React from 'react';
import { useEffect } from 'react';

export default function MetaTags(props) {
  useEffect(()=>{
    let title = window.document.documentElement.querySelector("title");
    title.innerHTML = props.text;
    // console.log(title,props.text,"slkdfjlskdjflskfdjlksdjfk")
  },[])
}